import React from 'react'
import bathroom2 from '../images/bathroom_2.jpg'

const Generalrepairs = () => {
  return (
    <section className="generalRepairs">
      <div className="container">
        <h2 className="generalRepairs__title" style={{ textAlign: 'left' }}>Design, Create or Repair</h2>
        <div className="generalRepairs__content">
          <div className="generalRepairs__text">
            <p>
              Our team have years of experience
              in designing and creating beautiful new kitchens
              and bathrooms.
            </p>
            <p>
              If a repair or a "face-lift" is more your bag then
              we can do that too! Whatever the job, we bring our highly-skilled
              and professional tradesmen to the table in order to give you the
              best results possible.
            </p>
          </div>
        </div>
        <div className="generalRepairs__image-container">
          <img
            src={bathroom2}
            alt="Modern bathroom design"
            className="generalRepairs__image"
          />
        </div>
      </div>
    </section>
  );
};

export default Generalrepairs
